// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetPatientAccountResponseModel {
    static getAttributeTypeMap() {
        return GetPatientAccountResponseModel.attributeTypeMap;
    }
}
GetPatientAccountResponseModel.discriminator = undefined;
GetPatientAccountResponseModel.additionalProperties = false;
GetPatientAccountResponseModel.attributeTypeMap = [
    {
        "name": "account",
        "baseName": "account",
        "type": "AccountModel"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "PatientModel"
    },
];
//# sourceMappingURL=getPatientAccountResponseModel.js.map